import { httpRequest } from '@/apis/request'

enum Apis {
  translate = 'guigui_user/translation',
}

/**
 * @description 获取柜柜翻译数据
 * @returns
 */
export function getGuiguiTranslate() {
  return httpRequest.get(Apis.translate)
}
